var map = {
	".": 318,
	"./": 318,
	"./LinearGradientWeb": 336,
	"./LinearGradientWeb/": 336,
	"./LinearGradientWeb/index": 336,
	"./LinearGradientWeb/index.js": 336,
	"./index": 318,
	"./index.js": 318
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1419;